<template>
  <v-menu
    min-width="auto"
    transition="fade-transition"
  >
    <template #activator="{ props }">
      <VueDatePicker
        v-bind="props"
        :model-value="modelValue"
        :min-date="minSelectableDate"
        locale="jp"
        format="yyyy-MM-dd"
        model-type="yyyy-MM-dd"
        first-day-of-week="1"
        placeholder="日付"
        :teleport="true"
        :enable-time-picker="false"
        :clearable="false"
        auto-apply
        @update:model-value="$emit('update:model-value', $event)"
      />
    </template>
  </v-menu>
</template>

<script>
export default {
  name: "DaytimeAdviceDateConditionInput",
  props: {
    modelValue: {
      type: [String, Date],
      default: null
    },
    minSelectableDate: {
      type: Date,
      default: null
    }
  },
  emits: ["update:model-value"]
};
</script>
